export default __webpack_public_path__ + "static/media/alamo-material-2.11833224.webp";